import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-send",
  "use": "icon-send-usage",
  "viewBox": "0 0 11.068 11",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 11.068 11\" id=\"icon-send\">\n  <path id=\"icon-send_路径_18194\" data-name=\"路径 18194\" d=\"M139.619,149.579,128.991,143.9a.218.218,0,0,0-.319.209l.824,9.815a.221.221,0,0,0,.308.187l3.429-1.44,1.879,2.132a.218.218,0,0,0,.374-.088l.9-3.374,3.231-1.363A.223.223,0,0,0,139.619,149.579Zm-4.506,4.2-.989-1.758-5.056-7.8,6.7,6.924Z\" transform=\"translate(-128.671 -143.873)\" fill=\"#fff\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol